// extracted by mini-css-extract-plugin
export default {"container":"UserDataForm_container__ho2ZT","button":"UserDataForm_button__102xg"};